module.exports = __webpack_public_path__ + "img/zakat.f5e51562.svg";